module.exports = {
  siteTitle: 'Zalo Solutions AB', // <title>
  manifestName: 'Zalo Solutions',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/gatsby-starter-directive/`, // This path is subpath of your hosting https://domain/portfolio

  // social
  socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/spdavid',
    },
    {
      icon: 'fa-linkedin',
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/in/davidopdendries',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/sharepointdavid',
    },
   
    {
      icon: 'fa-envelope-o',
      name: 'Email',
      url: 'mailto:david@zalosolutions.com',
    }, 
    {
      icon: 'fa-phone',
      name: 'Phone',
      url: 'tel:+46722695586',
    }
  ],
};
